import styled from 'styled-components'

export const Container = styled.div`

  /* margin: 0 auto; */
  
  margin: auto;

  a {

    display: flex;

    img {
      width: 16px;
      height: 16px;
    }

  }

`
